class StorePickupAvailability extends HTMLElement {
    constructor() {
        super();

        this.client = new window.ShopifyStorefrontClient(theme.storefront.endpoint, theme.storefront.access_token);
        this.lowStock = Number(this.getAttribute("data-low-stock"));
        this.productHandle = this.getAttribute("data-product-handle");

        this.setupListeners();
    }

    async connectedCallback() {
    }

    setupListeners() {
        document.querySelector(`#in-store-stock-checker`).addEventListener('click',
            this.viewStockChecker.bind(this)
        );
        document.querySelector(`#pickup-current-location`).addEventListener('click',
            this.getCurrentLocation.bind(this)
        );

        document.querySelector(`select[name="stock-size"]`).addEventListener('change',
            this.viewStockChecker.bind(this)
        );

        document.querySelector(`input[name="store-pickup-input"]`).addEventListener('change',
            this.onLocationChange.bind(this)
        );
    }
    async viewStockChecker() {
        document.querySelector('body').classList.add('open-cc');
        document.querySelector('.side-panel.stock-checker-drawer').classList.add('active');
        document.querySelector(`input[name="store-pickup-input"]`).value = '';
        const storeList = await this.getClosestStores(-27.47, 153.03, 100);
        this.updateStoresList(storeList, true);
    }

    async getCurrentLocation() {
    document.querySelector(`input[name="store-pickup-input"]`).value = '';
    const loadingOverlay = document.querySelector(`.stock-checker-drawer .loading-overlay`);
        if (loadingOverlay) {
            loadingOverlay.classList.add('show');
            document.querySelector(`#store-pickup-stores-list`).classList.add('loading');
        }
        function error() {
            document.querySelector('#pickup-current-location-error').classList.remove('hide-error');
            if (loadingOverlay) loadingOverlay.classList.remove('show');
        }

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(this.onGetCurrentLocationSuccess.bind(this), error);
        } else {
           console.log('Your browser cannot locate');
        }
    }

    async onGetCurrentLocationSuccess(position) {
        const storeList = await this.getClosestStores(position.coords.latitude, position.coords.longitude);
        document.querySelector(`input[name="store-pickup-input"]`).placeholder = 'Using Current Position';
        this.updateStoresList(storeList);
        const loadingOverlay = document.querySelector(`.stock-checker-drawer .loading-overlay`);
        if (loadingOverlay) {
            loadingOverlay.classList.remove('show');
            document.querySelector(`#store-pickup-stores-list`).classList.remove('loading');
        }    }

    async onLocationChange() {
        const loadingOverlay = document.querySelector(`.stock-checker-drawer .loading-overlay`);
        if (loadingOverlay) {
            loadingOverlay.classList.add('show');
            document.querySelector(`#store-pickup-stores-list`).classList.add('loading');
            document.querySelector(`input[name="store-pickup-input"]`).placeholder = 'Suburb/Postcode';

        }

        const locationInput = document.querySelector(`input[name="store-pickup-input"]`)?.value;
        let locationDetails = await this.getLocationDetails(locationInput);

        if (!locationDetails) {
            document.querySelector('#pickup-input-location-error').classList.remove('hide-error');
        } else {
            const storeList = await this.getClosestStores(locationDetails.lat, locationDetails.long);
            this.updateStoresList(storeList, locationDetails.sort)
        }
        if (loadingOverlay) {
            loadingOverlay.classList.remove('show');
            document.querySelector(`#store-pickup-stores-list`).classList.remove('loading');
        }
    }

    updateStoresList(stores, sort = false) {
        const storeListElement = document.querySelector("#store-pickup-stores-list");
        storeListElement.innerHTML = '';
        if (sort) {
            stores.sort((a, b) => {
                return b['quantityAvailable'] - a['quantityAvailable'];
            });
        }
        stores.forEach((store) => {
            let storeDiv = this.createStoreDiv(store);
            storeListElement.append(storeDiv);
        });
        document.querySelector('#pickup-input-location-error').classList.add('hide-error');
        document.querySelector('#pickup-current-location-error').classList.add('hide-error');
    }

    async getClosestStores(lat,long, storeAmount = 10) {
        const selectElement = document.querySelector('#store-pickup-size-select');
        let selectedSize = selectElement.options[selectElement.selectedIndex].value;

        const availability = await this.client.getProductVariantStoreAvailability(this.productHandle, lat, long, "Size", selectedSize, storeAmount);
        let storeList = availability.product.variantBySelectedOptions.storeAvailability.nodes;
        return storeList;
    }

    async getLocationDetails(location) {
        if (location === "") { return {lat: -27.47, long: 153.03, sort: true } } // if no location is entered in the input then default to brisbane location

        let results = await this.client.getPostcodeMetaobject(location.replace(' ', '_'), 'postcode_address_details');
        if (results.metaobject == null ) {
            return false;
        } else {
            return {
                lat: parseFloat(results.metaobject.fields[0].value),
                long: parseFloat(results.metaobject.fields[1].value),
                sort: false
            };
        }

    }

    createStoreDiv(store) {
        let storeDiv = document.createElement("div");
        storeDiv.classList.add("pickup-store");

        let stockLevel = '';

        if (store.quantityAvailable > this.lowStock ) {
            stockLevel = '<span class="stock-available"> - Available</span>';
        } else if (!store.available){
            stockLevel = '<span class="stock-unavailable"> - Sold Out</span>';
        } else if (store.quantityAvailable <= this.lowStock) {
            stockLevel = '<span class="low-stock"> - Low Stock</span>';
        } else {
            stockLevel = '<span class="stock-unavailable"> - Sold Out</span>';
        }

        storeDiv.innerHTML =
        `
            <div class="store-name">
                <span>${store.location.name}</span> ${stockLevel}
            </div>
            <div class="store-address">
                <span>${store.location.address.address1}</span>
                <br>
                <span>${store.location.address.province}, ${store.location.address.city} ${store.location.address.zip}</span>
                <br>
                <a href="tel:${store.location.address.phone}">${store.location.address.phone}</a>
            </div>
       `
        return storeDiv;
    }

}

customElements.define('store-pickup-availability', StorePickupAvailability);